import {Component, OnInit} from '@angular/core';
import { SmartPowerSummary } from "../../global/smartpower-types";
import { SmartpowerService } from "../../core/services/smartpower.service";
import { SmartpowerLocation } from 'src/app/global/types';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';

@Component({
    selector: 'app-smartpower',
    templateUrl: './smartpower.component.html',
    styleUrls: ['./smartpower.component.scss'],
    standalone: false
})
export class SmartpowerComponent implements OnInit {
  pageTitle = 'SMARTPOWER Summary'
  smartPowerSummaryData: SmartPowerSummary = {
    OverallSummary: [],
    FsPriorityLocation: [],
    OpsPriorityLocation: [],
    FsTopPerformer: [],
    OpsTopPerformer: []
  };
  locationData: SmartpowerLocation[] = []

  operationColumns = ['Location', 'Group Average', 'Detergent', 'Rinse Additive', 'Wash Tank']
  fssSafetyColumns = ['Location', 'Group Average', 'Wash Temp', 'Rinse Temp', 'Sanitizer']

  displayLoader = true;
  displayNavigation = false;
  displaySummary = true;

  selectedLocationMetric = 'sanitizer';

  constructor(
    private smartPowerService: SmartpowerService,
    private _mixpanelService: MixpanelService,
  ) { }

  async ngOnInit() {
    const smartPowerSummary = await this.smartPowerService.getSummaryData();
    if (smartPowerSummary != undefined) {
      this.smartPowerSummaryData = smartPowerSummary;
      this.smartPowerSummaryData.OpsTopPerformer = this.smartPowerSummaryData.OpsTopPerformer.reverse();
      this.smartPowerSummaryData.FsTopPerformer = this.smartPowerSummaryData.FsTopPerformer.reverse();
      this.displayNavigation = true;
    }
    this.displayLoader = false;
    this._mixpanelService.track('Smartpower Viewed');
  }

  async onSummaryClick() {
    this.displaySummary = true;
    this.pageTitle = 'SMARTPOWER Summary'
  }

  async onLocationClick() {
    this.displaySummary = false;
    this.pageTitle = 'SMARTPOWER Locations'
    const locationData = await this.smartPowerService.getLocationData(this.selectedLocationMetric);
    if (locationData != undefined) {
      this.locationData = locationData;
    }
  }

  async onLocationMetricChange(metric: any) {
    console.log(metric);
    this.selectedLocationMetric = metric;
    this.locationData = [];
    const locationData = await this.smartPowerService.getLocationData(this.selectedLocationMetric);
    if (locationData != undefined) {
      this.locationData = locationData;
    }
  }
}
